export const SET_PRND = 'SET_PRND';
export const CLEAR_PRND = 'CLEAR_PRND';

export const clearPrnd = {
  type: CLEAR_PRND,
}

export const setPrnd = (data) => {
  return {
    type: SET_PRND,
    payload: data,
  }
}